export interface GetCurrencyTypeListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetCurrencyTypeListPagingAndFilterResponseData
}

export interface GetCurrencyTypeListPagingAndFilterResponseData {
    items: GetCurrencyTypeListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetCurrencyTypeListPagingAndFilterResponseItem {
    currencyTypeId: string
    code: string
    name?: string
    symbol?: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetCurrencyTypeListPagingAndFilterResponseData: GetCurrencyTypeListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}